export class RestaurantMenu{
	init() {
		var categories = $('.features-list--menu-categories .features-list__item'),
			menus = $('.features-list--restaurant-menu .features-list__item'),
			menusPosition = $('.features-list--restaurant-menu').length ? $('.features-list--restaurant-menu').offset().top : 0;

		categories.each(function() {
			$(this).on('click', function() {
				var $this = $(this);
				categories.removeClass('active');
				$this.addClass('active'); 

				menus.removeClass('active');
				menus.filter('[data-item="'+ $this.data('id') +'"]').addClass('active');
				$('html, body').animate({
					scrollTop: menusPosition - 100
				}, 500);
				
			})
		});
	}
}